<script setup lang="ts">
import type { PropertyPriceProps } from '.';

import { propertyPriceInputVariants } from '.';

const props = withDefaults(defineProps<PropertyPriceProps>(), {
	variant: 'primary'
});

const min = defineModel<number | null>('min');
const max = defineModel<number | null>('max');
</script>

<template>
	<IntervalInput
		v-model:min="min"
		v-model:max="max"
		title="Valor de venda"
		unit="currency"
		min-label="Preço mínimo"
		max-label="Preço máximo"
		update-on="blur"
		:variant="props.variant"
		:input-classes="propertyPriceInputVariants({ variant: props.variant })"
	/>
</template>
